import axios from 'axios'
import {
  ACTIVITY_BY_PROJECT_LIST_FAIL,
  ACTIVITY_BY_PROJECT_LIST_REQUEST,
  ACTIVITY_BY_PROJECT_LIST_SUCCESS,
  ACTIVITY_LIST_FAIL,
  ACTIVITY_LIST_REQUEST,
  ACTIVITY_LIST_SUCCESS,
  ACTIVITY_MARK_AS_READ_FAIL,
  ACTIVITY_MARK_AS_READ_REQUEST,
  ACTIVITY_MARK_AS_READ_SUCCESS,
  ACTIVITY_MARK_MESSAGES_AS_READ_FAIL,
  ACTIVITY_MARK_MESSAGES_AS_READ_REQUEST,
  ACTIVITY_MARK_MESSAGES_AS_READ_SUCCESS,
  ACTIVITY_MESSAGE_CREATE_FAIL,
  ACTIVITY_MESSAGE_CREATE_REQUEST,
  ACTIVITY_MESSAGE_CREATE_SUCCESS,
} from '../constants/activityConstants'

export const getActivityByUserID = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: ACTIVITY_LIST_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`/api/activity/list`, config)

    dispatch({
      type: ACTIVITY_LIST_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: ACTIVITY_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const getActivityByProject = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ACTIVITY_BY_PROJECT_LIST_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`/api/activity/project/${id}`, config)

    dispatch({
      type: ACTIVITY_BY_PROJECT_LIST_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: ACTIVITY_BY_PROJECT_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const createMessage = (activity) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ACTIVITY_MESSAGE_CREATE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(`/api/activity/message`, activity, config)

    dispatch({
      type: ACTIVITY_MESSAGE_CREATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: ACTIVITY_MESSAGE_CREATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const markActivityAsRead = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ACTIVITY_MARK_AS_READ_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(
      `/api/activity/mark-as-read`,
      { id },
      config
    )

    dispatch({
      type: ACTIVITY_MARK_AS_READ_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: ACTIVITY_MARK_AS_READ_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const markMessagesAsRead = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ACTIVITY_MARK_MESSAGES_AS_READ_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(
      `/api/activity/mark-messages-as-read`,
      { id },
      config
    )

    dispatch({
      type: ACTIVITY_MARK_MESSAGES_AS_READ_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: ACTIVITY_MARK_MESSAGES_AS_READ_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}
